import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire4Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.INVALID);

  const collectedData = mdq.collectedData;

  useEffect(() => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.INVALID,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    if (medicalUUID) {
      dispatch(
        submitOrLogMdq({
          data: {
            uid: medicalUUID,
            methodKey: methodKey.toLowerCase(),
            status: 'draft',
            data: {
              ...collectedData,
              [WEIGHT_LOSS_KEYS.INVALID]: answerData,
            },
          },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions} pageTitle={questionnaire?.title}>
      <Col alignItems="center" textAlign="center" mt={24} px={2}>
        <UiText fontSize="2xl" fontWeight="bold">
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map((item, index) => {
          return (
            <UiText key={index} color="blackSecondary" fontSize="sm" mt={4}>
              {item}
            </UiText>
          );
        })}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
